var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  @jsx h

import { h } from 'preact';
import PureComponent from '../lib/preact-pure-component';
import { Message } from './Message';
import { Date } from './Date';

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_28-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_28-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_28-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_28-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_28-avatar--right',
  'date': 'dhfc-1_0_0-beta_28-date',
  'date--isFirst': 'dhfc-1_0_0-beta_28-date--isFirst',
  'message': 'dhfc-1_0_0-beta_28-message',
  'message--left': 'dhfc-1_0_0-beta_28-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_28-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_28-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_28-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_28-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_28-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_28-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_28-message__image',
  'message__images': 'dhfc-1_0_0-beta_28-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_28-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_28-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_28-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_28-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_28-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_28-message__name',
  'message__content': 'dhfc-1_0_0-beta_28-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_28-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_28-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_28-message__content--showName'
};

var ChatLog = function (_PureComponent) {
  _inherits(ChatLog, _PureComponent);

  function ChatLog() {
    _classCallCheck(this, ChatLog);

    return _possibleConstructorReturn(this, (ChatLog.__proto__ || Object.getPrototypeOf(ChatLog)).apply(this, arguments));
  }

  _createClass(ChatLog, [{
    key: 'render',
    value: function render() {
      var messages = this.props.messages;

      var className = '' + styles.chatLog + (this.props.className ? ' ' + this.props.className : '');

      return h(
        'div',
        { className: className },
        messages.map(function (message, idx) {
          return [h(Date, { date: message.date, index: idx, key: 'date_' + idx }), h(Message, {
            key: idx,
            isLastInGroup: isLastInGroup(messages, idx),
            message: message
          })];
        })
      );
    }
  }]);

  return ChatLog;
}(PureComponent);

function isLastInGroup(messages, index) {
  return messages.length - 1 === index;
}

export default ChatLog;